import React from 'react';
import { Card, CardContent, CardActions, Skeleton } from '@mui/material';

function SkeletonCard() {
  return (
    <Card elevation={1} sx={{ height: '100%' }}>
      <CardContent>
        <Skeleton variant="text" width="70%" height={32} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="85%" />
      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-end' }}>
        <Skeleton variant="circular" width={28} height={28} />
        <Skeleton variant="circular" width={28} height={28} />
      </CardActions>
    </Card>
  );
}

export default SkeletonCard;
